<template>
  <div class="manage-layout">
    <!-- 顶部header -->
    <el-header class="main-header">
      <div class="logo-container">
        <img src="@/assets/game.jpg" class="logo" />
        <span class="system-name">管理后台</span>
      </div>

      <div class="right-menu">
        <el-dropdown trigger="click" @command="handleCommand">
          <div class="avatar-wrapper">
            <el-avatar :size="36" :src="user.avatar" class="user-avatar" />
          </div>
          <el-dropdown-menu slot="dropdown">
            <div class="dropdown-header">
              <span class="username">{{ user.name }}</span>
            </div>
            <el-dropdown-item command="logout">
              <i class="el-icon-switch-button"></i>退出登录
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>

    <div class="layout-body">
      <!-- 左侧菜单 -->
      <div class="sidebar">
        <el-menu
          :default-active="activeMenu"
          class="menu-container"
          @select="handleSelect"
        >
        <el-menu-item index="/">
            <i class="el-icon-s-shop"></i>
            <span slot="title">首页</span>
          </el-menu-item>
          <el-menu-item index="/manage/staff">
            <i class="el-icon-user"></i>
            <span slot="title">人员管理</span>
          </el-menu-item>

          <el-menu-item index="/manage/card">
            <i class="el-icon-key"></i>
            <span slot="title">卡密管理</span>
          </el-menu-item>
          <el-menu-item index="/manage/moquAccountManage">
            <i class="el-icon-key"></i>
            <span slot="title">魔趣账号管理</span>
          </el-menu-item>
          <el-menu-item index="/manage/moquGameManage">
            <i class="el-icon-key"></i>
            <span slot="title">魔趣游戏管理</span>
          </el-menu-item>
          <el-menu-item index="/manage/moquDirectLimit">
            <i class="el-icon-setting"></i>
            <span slot="title">魔趣直连额度配置</span>
          </el-menu-item>
          <el-menu-item index="/manage/userRiskMonitor">
            <i class="el-icon-warning-outline"></i>
            <span slot="title">用户风控监控</span>
          </el-menu-item>

          <el-menu-item index="/manage/mqHistoryDownload">
            <i class="el-icon-key"></i>
            <span slot="title">魔趣下载日志</span>
          </el-menu-item>

          <!-- <el-menu-item index="/manage/pan123Token">
            <i class="el-icon-coin"></i>
            <span slot="title">123网盘Token管理</span>
          </el-menu-item> -->

          <el-menu-item index="/manage/urlDownloadLogs">
            <i class="el-icon-s-data"></i>
            <span slot="title">直接下载统计日志</span>
          </el-menu-item>

          <!-- <el-menu-item index="/manage/tianyi">
            <i class="el-icon-cloudy"></i>
            <span slot="title">天翼云管理</span>
          </el-menu-item>

          <el-menu-item index="/manage/tianyiAutoUploadConfig">
            <i class="el-icon-setting"></i>
            <span slot="title">天翼云自动上传配置</span>
          </el-menu-item>

          <el-menu-item index="/manage/tianyiDirectRequests">
            <i class="el-icon-document-copy"></i>
            <span slot="title">直连申请管理</span>
          </el-menu-item> -->

        </el-menu>
      </div>

      <!-- 右侧内容区 -->
      <div class="main-content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserInfo, logout } from "@/api";
export default {
  name: "ManageLayout",
  data() {
    return {
      activeMenu: this.$route.path,
      isLoggedIn: false,
      user: {
        name: "Admin",
        avatar: "", // 这里可以设置默认头像
      },
    };
  },
  mounted() {
    this.isLoggedIn = localStorage.getItem("token") ? true : false;
    if (this.isLoggedIn) {
      this.user = JSON.parse(localStorage.getItem("userInfo"));
    }
  },
  methods: {
    handleSelect(index) {
      this.$router.push(index);
    },
   async handleCommand(command) {
      if (command === "logout") {
        if (command === "logout") {
        try {
          await logout();
          localStorage.removeItem("token");
          this.isLoggedIn = false;
          localStorage.removeItem("userInfo");
          this.user = {};
          this.$router.push("/login");
        } catch (error) {
          console.log(error);
        }
      }
      }
    },
  },
};
</script>

<style scoped>
.manage-layout {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.layout-body {
  flex: 1;
  display: flex;
  overflow: hidden;
}

.main-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  border-bottom: 1px solid #dcdfe6;
  padding: 0 20px;
}

.logo-container {
  display: flex;
  align-items: center;
}

.logo {
  height: 40px;
  margin-right: 10px;
}

.system-name {
  font-size: 18px;
  font-weight: bold;
  color: #303133;
}

.right-menu {
  display: flex;
  align-items: center;
}

.avatar-wrapper {
  cursor: pointer;
}

.dropdown-header {
  padding: 10px 20px;
  border-bottom: 1px solid #ebeef5;
}

.username {
  font-size: 14px;
  color: #606266;
}

.sidebar {
  width: 200px;
  height: 100%;
  background-color: #fff;
  border-right: 1px solid #dcdfe6;
}

.menu-container {
  height: 100%;
  border-right: none;
}

.main-content {
  flex: 1;
  padding: 20px;
  background-color: #f5f7fa;
  overflow-y: auto;
}
</style>
